import React, { useState, useEffect } from "react";
import { getData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import { Link } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";

const Stock = () => {
  //module variables
  const [stockData, setstockData] = useState({ all: [], filtered: [] });

  useEffect(() => {
    getData("fetch_stock")
      .then((data) => {
        setstockData({ all: data, filtered: data });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //search drug
  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    const filteredData = stockData.all.filter(
      (item) =>
        (item.item_code !== null &&
          item.item_code.toString().toLowerCase() ===
            searchQuery.toLowerCase()) ||
        (item.manufacturer_item !== null &&
          item.manufacturer_item
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.date_diff !== null &&
          item.date_diff
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.status !== null &&
          item.status
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase()))
    );

    setstockData({ ...stockData, filtered: filteredData });
  };

  const printPdf = (e) => {
    e.preventDefault();

    let title = "STOCK";
    let tbl = document.getElementById("stock_div").innerHTML;

    let j = `
  <div class="row">
  <br><br><br>
  <div class="row">
  <div class="col-md-4" style="font-size:25px;font-weight:bold;text-align:center;">${title}</div>
  <br>
  <div class="col-md-4 ml-auto" style="font-weight:bold; text-align: right"></div>
  </div>
  <div>${tbl}</div>  
  </div>
  `;

    var val = htmlToPdfmake(j);
    var dd = {
      pageOrientation: "landscape",
      pageMargins: [40, 60, 40, 60],
      content: val,
      pageSize: "A4",
    };
    pdfMake.createPdf(dd).download();
  };

  return (
    <div>
      <div className="container">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Stock
              </li>
            </ol>
          </nav>
          <hr />
        </div>
        <div className="card p-4">
          <input
            type="text"
            className="form-control col-md-12 text-center mb-2"
            placeholder="Type to search..."
            onInput={handleSearch}
          />
          <div className="col-md-12 justify-content-center" id="stock_div">
            <table
              className="table table-bordered table-bordered table-sm"
              style={{ maxHeight: "500px" }}
              id={"stock"}
            >
              <thead className="table-fixed-header">
                <tr>
                  <th>Code</th>
                  <th>Items</th>                
                  <th>Price Per Item</th>
                  <th>Stocked</th>
                  <th>Sold</th>
                  <th>Expired / Spoilt</th>
                  <th>Available</th>
                  <th>Availability</th>
                  <th>Expiry Date</th>
                  <th>Expiry</th>
                </tr>
              </thead>
              <tbody>
                {stockData.filtered.map((dt) => {
                  return (
                    <tr key={dt.id}>
                      <td>{dt.item_code}</td>
                      <td>{dt.item_detail}</td>                     
                      <td>
                        {dt.retail_price_per_item
                          ? parseFloat(
                              dt.retail_price_per_item
                            ).toLocaleString()
                          : dt.retail_price_per_item}
                      </td>
                      <td>
                        {dt.quantity_stocked
                          ? parseFloat(dt.quantity_stocked).toLocaleString()
                          : dt.quantity_stocked}
                      </td>
                      <td>
                        {dt.quantity_sold
                          ? parseFloat(dt.quantity_sold).toLocaleString()
                          : dt.quantity_sold}
                      </td>
                      <td>
                        {dt.quantity_expired_or_spoilt
                          ? parseFloat(
                              dt.quantity_expired_or_spoilt
                            ).toLocaleString()
                          : dt.quantity_expired_or_spoilt}
                      </td>
                      <td>
                        {dt.quantity_available
                          ? parseFloat(dt.quantity_available).toLocaleString()
                          : dt.quantity_available}
                      </td>
                      <td
                        style={
                          dt.status === "AVAILABLE"
                            ? { color: "green", fontWeight: "bolder" }
                            : { color: "red", fontWeight: "bolder" }
                        }
                      >
                        {dt.status}
                      </td>
                      <td>{dt.expiry_date}</td>
                      <td>
                        {dt.date_diff.includes("Expired") ? (
                          <span style={{ color: "red", fontWeight: "bolder" }}>
                            {dt.date_diff}
                          </span>
                        ) : (
                          <span
                            style={{ color: "green", fontWeight: "bolder" }}
                          >
                            {dt.date_diff}
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p>
            <button
              type="button"
              className="btn btn-sm btn-info col-1"
              onClick={printPdf}
            >
              Print
            </button>
            <ReactHTMLTableToExcel
              className="btn btn-sm btn-success col-1 ml-1"
              table="stock"
              filename="stock"
              sheet="stock"
              buttonText="Export"
            />
          </p>
          <div className={"row justify-content-center"}>
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stock;
